import logo from '../img/logo.svg';
import '../css/App.css';
import '../css/button.css';
import { useQuery, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { useDocumentTitle } from '../ts/useDocumentTitle';

type PartyUser = { id: number; name: string; points: number };
type Party = { id: number; users: PartyUser[]; started: boolean };

async function fetchParty(partyId: number): Promise<Party> {
  const response = await fetch(`http://localhost:5001/api/parties/${partyId}`);

  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || response.statusText);
  }

  return response.json();
}

type CreateGameLocationState = {
  partyId?: number;
  playerName?: string;
  started?: boolean;
};
async function startparty(partyId: number, user: PartyUser) {
  const response = await fetch(`http://localhost:5001/api/parties/${partyId}/start`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ user }),
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || response.statusText);
  }

  return response.json();
}
function CreateGameComponent() {
  useDocumentTitle('Create Game');
  const location = useLocation();
  const locationState = (location.state as CreateGameLocationState) ?? {};
  const partyId = locationState.partyId;

  const displayCode =
    typeof partyId === 'number' ? partyId.toString().padStart(6, '0') : 'null';

  const {
    data: party,
    isLoading,
    isError,
    error,
  } = useQuery<Party, Error>({
    queryKey: ['party', partyId],
    queryFn: () => fetchParty(partyId as number),
    enabled: typeof partyId === 'number',
    retry: 0,
  });
  const players = party?.users ?? [];
  const started = party?.started ?? null;

  function getplayerid() {
    for (let i = 0; i < players.length; i++) {
      if (players[i].name === locationState.playerName) {
        return players[i].id;
      }
    }
    return null;
  }
  const playerid = getplayerid();
  if (started) {
    window.location.href = `/Game/${displayCode}/${playerid}`;
  }
  const canProceed = players.length > 1;
  return (
    <div className="App">
      <header className='App-header'></header>
      <main className="App-body">
        <div className="content-card">
          <img src={logo} className="App-logo" alt="logo" />

          <p className="pill">Game Code</p>
          <div className="code-pill">{displayCode}</div>

          <div className="list-panel">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <h3 style={{ margin: 0, color: '#05d9e8' }}>Players</h3>
              <span className="pill">{players.length} joined</span>
            </div>

            {typeof partyId !== 'number' && (
              <p style={{ marginTop: 8 }}>Start a new game to see players here.</p>
            )}
            {isLoading && typeof partyId === 'number' && <p>Loading players…</p>}
            {isError && typeof partyId === 'number' && (
              <p style={{ marginTop: 8 }}>Failed to load players: {error?.message}</p>
            )}
            {!isLoading && !isError && players.length > 0 && (
              <div className='App-lobby'>
                {players.map((player) => (
                  <div className='player-row'  key={player.id} >
                    <strong>{player.name}</strong>
                    <span className='player-points'>{player.points} pts</span>
                  </div>
                ))}
              </div>
            )}
            {!isLoading && !isError && players.length === 0 && typeof partyId === 'number' && (
              <p style={{ marginTop: 8 }}>No players have joined yet.</p>
            )}
          </div>

          <div className="button-row">
            {canProceed ? (
              <Link to={`/Game/${displayCode}/${playerid}`} style={{ flex: 1 }}>
                <button className="Base-button-ready" style={{ width: '100%' }} onClick={() => startparty(partyId as number, { id: 1, name: locationState.playerName || 'Player', points: 0 })}>Start game</button>
              </Link>
            ) : (
              <button disabled className="Base-button-not-ready" style={{ width: '100%' }}>Start game</button>
            )}
          </div>
        </div>
      </main>
      <footer className="App-footer">
        
      </footer>
    </div>
  );
}

export default function CreateGame() {
  const queryClient = new QueryClient();
  return (
    <QueryClientProvider client={queryClient}>
      <CreateGameComponent />
    </QueryClientProvider>
  );
}